import gql from 'graphql-tag';

export default gql`
    mutation SetPassword($input: SetPasswordInput!) {
        setPassword(input: $input) {
            clientMutationId
        }
    }
`;